<template>
  <div class="login-page">
    <div class="login-gradient-bg">
      <div class="gradient-shimmer"></div>
      <div class="liquid-effect"></div>
      <div class="energy-lines"></div>
    </div>
    
    <div class="login-container">
      <div class="login-card">
        <Logo class="login-logo" />
        
        <h2 class="welcome-text">Welcome back, driver!</h2>
        
        <div class="login-form">
          <button @click="login" class="btn btn-primary btn-login">
            <i class="bi bi-box-arrow-in-right"></i>
            <span>Sign In</span>
          </button>
          
          <p class="login-help">Having trouble? Contact your manager for assistance.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuth0 } from '@auth0/auth0-vue'
import Logo from '@/components/Logo.vue'

export default {
  name: 'LoginPage',
  components: {
    Logo
  },
  setup() {
    const { loginWithRedirect } = useAuth0()
    
    const login = () => {
      loginWithRedirect()
    }
    
    return {
      login
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-gradient-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #10b981 0%, #6366F1 100%);
  z-index: -1;
}

.gradient-shimmer {
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%);
  animation: shimmer 8s infinite linear;
}

.liquid-effect {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%);
  transform-origin: bottom;
  animation: wave 15s infinite ease-in-out;
}

.energy-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px),
    linear-gradient(0deg, rgba(255,255,255,0.05) 1px, transparent 1px);
  background-size: 20px 20px;
  animation: pulse 4s infinite ease-in-out;
}

@keyframes shimmer {
  0% {
    transform: translate(-25%, -25%) rotate(0deg);
  }
  100% {
    transform: translate(-25%, -25%) rotate(360deg);
  }
}

@keyframes wave {
  0%, 100% {
    transform: scaleY(1.02);
  }
  50% {
    transform: scaleY(0.98);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.7;
  }
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: 0 1.5rem;
  z-index: 1;
}

.login-card {
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-logo {
  margin-bottom: 1.5rem;
}

.welcome-text {
  color: var(--text-secondary);
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 2rem;
  text-align: center;
}

.login-form {
  width: 100%;
}

.btn-login {
  width: 100%;
  height: 48px;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.login-help {
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin-bottom: 0;
}
</style>